/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse
 */
export interface JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse
     */
    url?: string;
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse {
    return JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseToJSON(value?: JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'url': value.url,
    };
}

